import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 批量删除选中项")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除 ")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认")

import { ref, reactive, nextTick, computed } from 'vue'
import { getShelfInfoList, addShelfInfo, delShelfInfo, editShelfInfo, getShelfInfoSelectList } from '@/service/main/warehouse';
import { ElMessage, ElMessageBox } from 'element-plus';
import { exportExcel } from "@/utils/exportExcel";
import Pagination from '@/components/Pagination/index.vue'




//货架类型下拉框数据定义

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const GoodsshetypeEnum: any = ref([])
//所属区域下拉框数据定义
const regionEnum: any = ref([])
const getSelect = () => {
  const obj = {
    CodeList: ["belong_region", "shelves_type"]
  }
  getShelfInfoSelectList(obj).then((res) => {
    if (res.code == 200) {
      const { data } = res
      regionEnum.value = data[0]
      GoodsshetypeEnum.value = data[1]
    }
  }).catch((err) => {
    ElMessage.error(err)
  })
}
getSelect()
//查询
const formModel = reactive({
  Code: '',
  GoodsshetypeName: '',
  RegName: '',
  Isvirtual: '',
  PageNo: 1,
  PageSize: 10
});

//列表
let tableData = ref([]);

//列表的数据条数
const totalItems = ref<number>(0);

//获取菜单列表
const getTabelData = () => {
  getShelfInfoList(formModel).then(res => {
    // console.log(res)
    if (res.code == 200) {
      const { data } = res;
      const result = data;
      tableData.value = result.rows;
      totalItems.value = result.totalRows;
    } else {
      ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
    }
  }).catch(err => {
    console.log(err)
    ElMessage.error(err)
  })
}

getTabelData();

//重置搜索
const resetForm = () => {
  formModel.Code = '';
  formModel.GoodsshetypeName = '';
  formModel.RegName = '';
  formModel.Isvirtual = '';
  formModel.PageNo = 1;
  formModel.PageSize = 10;
  getTabelData();
}

//选中的行
const checkRows = ref<{ id: number }[]>([]);

// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
}
//导出
const handExport = () => {
  let entozh = {
    id: "序号",
    code: "货架编码",
    goodsshetypeName: "货架类型",
    regIdName: "所属区域",
    heavy: "承重(kg)",
    // xcoordinate: 'X坐标(mm)',
    // ycoordinate: 'Y坐标(mm)',
    length: '长度(mm)',
    width: '宽度(mm)',
    rownumber: '排数',
    columnsnumber: '列数',
    layersnumber: '层数',

  };
  exportExcel(checkRows.value, entozh, "xlsx", "货架信息表");
}

//批量删除
const handleBatchDelete = () => {
  const handleArr: number[] = [];
  checkRows.value.forEach(item => {
    handleArr.push(item.id);
  })
  const obj = { id: handleArr };
  ElMessageBox.confirm('是否确认删除？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    delShelfInfo(obj).then((res: any) => {
      if (res?.code === 200) {
        ElMessage.success('删除成功')
        // 刷新列表
        getTabelData()
      } else {
        ElMessage.error(`删除失败${res?.code}:${JSON.stringify(res.message)}`)
      }
    }).catch((err: any) => {
      console.log(err);
      ElMessage.error(`删除失败${err}`)
    })
  }).catch(() => {
    ElMessage.info('已取消删除')
  })
}

//删除
const deleteRole = (code: number) => {
  const obj = { id: [code] };
  ElMessageBox.confirm('是否确认删除？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    delShelfInfo(obj).then((res: any) => {
      if (res?.code === 200) {
        ElMessage.success('删除成功')
        // 刷新列表
        getTabelData()
      } else {
        ElMessage.error(`删除失败${res?.code}:${JSON.stringify(res.message)}`)
      }
    }).catch((err: any) => {
      console.log(err);
      ElMessage.error(`删除失败${err}`)
    })
  }).catch(() => {
    ElMessage.info('已取消删除')
  })
}

//窗口类型
const dialogType = ref('add')

const dialogVisible = ref(false);

//操作表单ref
const dialogRef = ref();

//打开窗口
const openDialog = (type: number, scope: any = {}) => {
  if (type == 1) {
    dialogType.value = 'add'
  } else {
    dialogType.value = 'edit'
    // addForm.value = Object.assign({}, scope);
    addForm.value.code = scope.code
    addForm.value.name = scope.name
    addForm.value.goodsshetypeName = scope.goodsshetypeName
    addForm.value.regName = scope.regName
    addForm.value.heavy = scope.heavy
    // addForm.value.xcoordinate = scope.xcoordinate
    // addForm.value.ycoordinate = scope.ycoordinate
    addForm.value.length = scope.length
    addForm.value.width = scope.width
    addForm.value.rowNumber = scope.rowNumber
    addForm.value.columnsNumber = scope.columnsNumber
    addForm.value.layersNumber = scope.layersNumber
    addForm.value.id = scope.id
  }
  dialogVisible.value = true;
  nextTick(() => {
    dialogRef.value.clearValidate();
  })
}

//添加/编辑参数
let addForm = ref({
  code: '',
  name: '',
  goodsshetypeName: '',
  regName: '',
  id: 0,
  heavy: 0,
  // xcoordinate: 0,
  // ycoordinate: 0,
  length: 0,
  width: 0,
  rowNumber: 0,
  columnsNumber: 0,
  layersNumber: 0,

})

// 非汉字校验
var validatorCode = (rule: any, value: any, callback: any) => {
  if (!value) {
    callback()
  } else {
    const reg = /[\u4E00-\u9FA5]/g;
    if (!reg.test(value)) {
      callback();
    } else {
      return callback(new Error("编号不能存在汉字"));
    }
  }
};

//rules
const formRules = {
  code: [{ required: true, message: '货架编号不能为空', trigger: 'blur' }, { validator: validatorCode, trigger: 'blur' }],
  name: [{ required: true, message: '货架名称不能为空', trigger: 'blur' }],
  goodsshetypeName: [{ required: true, message: '货架类型不能为空', trigger: 'blur' }],
  // heavy: [{ required: true, message: '货架承重不能为空', trigger: 'blur' }],
  regName: [{ required: true, message: '货架位置不能为空', trigger: 'blur' }],
  // xcoordinate: [{ required: true, message: '货架X坐标不能为空', trigger: 'blur' }],
  // ycoordinate: [{ required: true, message: '货架Y坐标不能为空', trigger: 'blur' }],
  // length: [{ required: true, message: '货架长度不能为空', trigger: 'blur' }],
  // width: [{ required: true, message: '货架宽度不能为空', trigger: 'blur' }],
  rownumber: [{ required: true, message: '货架排数不能为空', trigger: 'blur' }],
  columnsnumber: [{ required: true, message: '货架列数不能为空', trigger: 'blur' }],
  layersnumber: [{ required: true, message: '货架层数不能为空', trigger: 'blur' }]
}

//操作提交
const confirm = () => {
  dialogRef.value.validate((vali: any) => {
    if (vali) {
      //添加
      if (dialogType.value == 'add') {
        addShelfInfo(addForm.value).then(res => {
          if (res.code == 200) {
            ElMessage.success('添加成功');
            getTabelData();
            dialogVisible.value = false;
          } else {
            ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        editShelfInfo(addForm.value).then(res => {
          if (res.code == 200) {
            ElMessage.success('编辑成功');
            getTabelData();
            dialogVisible.value = false;
          } else {
            ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    } else {
      ElMessage.warning('表单验证失败');
    }
  })

}

//关闭窗口
const closeDialog = () => {
  addForm.value = {
    code: '',
    name: '',
    goodsshetypeName: '',
    regName: '',
    id: 0,
    heavy: 0,
    // xcoordinate: 0,
    // ycoordinate: 0,
    length: 0,
    width: 0,
    rowNumber: 0,
    columnsNumber: 0,
    layersNumber: 0,

  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _unref(formModel),
        "label-width": "120px",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "货架编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).Code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).Code) = $event)),
                        placeholder: "请输入区域名称",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "货架类型:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(formModel).GoodsshetypeName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).GoodsshetypeName) = $event)),
                        placeholder: "请选择所属仓库",
                        size: "large",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(GoodsshetypeEnum.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.label,
                              label: item.label,
                              value: item.label
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "所属区域:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(formModel).RegName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).RegName) = $event)),
                        placeholder: "请选择所属区域",
                        size: "large",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionEnum.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.label,
                              label: item.label,
                              value: item.label
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-delete",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: handleBatchDelete
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _hoisted_9
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_form, {
                "label-position": "left",
                "label-width": "180px",
                inline: "",
                class: "demo-table-expand"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "长度(mm)" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.length), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "宽度(mm)" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.width), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "排" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.rowNumber), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "列" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.columnsNumber), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "层" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.layersNumber), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "货架编号",
            prop: "code",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "货架名称",
            prop: "name",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "货架类型",
            prop: "goodsshetypeName",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "所属区域",
            prop: "regName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "承重(kg)",
            prop: "heavy",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "长度(mm)",
            prop: "length",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "宽度(mm)",
            prop: "width",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "排列层",
            prop: "rowNumber",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.rowNumber) + _toDisplayString(scope.row.columnsNumber) + _toDisplayString(scope.row.layersNumber), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "200px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-edit",
                onClick: ($event: any) => (openDialog(2, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-delete",
                onClick: ($event: any) => (deleteRole(scope.row.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: _unref(formModel).PageNo,
        "onUpdate:page": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).PageNo) = $event)),
        limit: _unref(formModel).PageSize,
        "onUpdate:limit": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formModel).PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '添加货架' : '编辑货架',
      width: "50%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "120px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "货架编号:",
                      prop: "code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).code,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).code) = $event)),
                          disabled: dialogType.value == 'edit',
                          placeholder: "请输入货架编号",
                          clearable: ""
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "货架名称:",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).name,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).name) = $event)),
                          placeholder: "请输入货架名称",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "货架类型:",
                      prop: "goodsshetypeName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).goodsshetypeName,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).goodsshetypeName) = $event)),
                          placeholder: "请选择货架类型",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(GoodsshetypeEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.label,
                                label: item.label,
                                value: item.label
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "所属区域:",
                      prop: "regName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).regName,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).regName) = $event)),
                          placeholder: "请选择所属区域",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.label,
                                label: item.label,
                                value: item.label
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  prop: "heavy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "承重(kg):",
                      prop: "heavy"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).heavy,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(addForm).heavy) = $event)),
                          modelModifiers: { number: true },
                          min: "1",
                          placeholder: "请输入承重",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "长(mm):",
                      prop: "length"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).length,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(addForm).length) = $event)),
                          modelModifiers: { number: true },
                          min: "1",
                          type: "number",
                          placeholder: "请输入长(mm)",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "宽(mm):",
                      prop: "width"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).width,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(addForm).width) = $event)),
                          modelModifiers: { number: true },
                          min: "1",
                          type: "number",
                          placeholder: "请输入宽(mm)",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "排数:",
                      prop: "rowNumber"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).rowNumber,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(addForm).rowNumber) = $event)),
                          modelModifiers: { number: true },
                          min: "1",
                          type: "number",
                          placeholder: "请输入排数",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "列数:",
                      prop: "columnsNumber"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).columnsNumber,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(addForm).columnsNumber) = $event)),
                          modelModifiers: { number: true },
                          min: "1",
                          type: "number",
                          placeholder: "请输入列数",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "层数:",
                      prop: "layersNumber"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).layersNumber,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(addForm).layersNumber) = $event)),
                          modelModifiers: { number: true },
                          min: "1",
                          type: "number",
                          placeholder: "层数",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})